module.exports = __webpack_public_path__ + "static/freewrite-bc7b7bb82b6831b6d406bca8c6d4a28c.jpg";